module.exports = __webpack_public_path__ + "img/crystal.16598985.svg";